import { render } from "./account-check.vue?vue&type=template&id=4f06815f&scoped=true&ts=true"
import script from "./account-check.vue?vue&type=script&lang=ts"
export * from "./account-check.vue?vue&type=script&lang=ts"

import "./account-check.vue?vue&type=style&index=0&id=4f06815f&scoped=true&lang=stylus"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f06815f"]])

export default __exports__